<template>
    <BlockWrapper
        v-for="block in pageBlocks"
        :key="block.canonicalUid"
        :block="block"
    />
</template>

<script setup>
    import premierBlocks from '~/temp/premier.json'

    import BlockWrapper from '~/components/blocks/BlockWrapper.vue'

    const pageType = inject('page-type', 'home')

    const { entry, digistormSettings } = storeToRefs(useSiteStore())

    const { contentBuilderKeys, queryContentBuilder } = useContentBuilder()

    const contentQuery = await queryContentBuilder(entry.value)

    const contentBuilderKey = computed(() => {
        return contentBuilderKeys[entry.value?.__typename] ?? 'contentBuilder'
    })

    const queryData = async () => {
        if (!contentQuery) {
            return
        }

        // check if this entry already has data
        if (entry.value?.fetched) {
            return
        }

        const { data: contentData, error: contentError } = await useAsyncQuery({
            query: contentQuery,
            variables: {
                canonicalUid: entry.value?.canonicalUid
            },
            key: `${entry.value?.uri}-content`,
            cache: false,
        })

        if (!isEmpty(contentError.value)) {
            throw createError(contentError.value)
        }


        // merge entry data with content data
        entry.value = merge({}, entry.value, {
            fetched: true,
            ...contentData.value?.entry
        })

    }

    await queryData()

    const pageBlocks = computed(() => {
        return get(entry.value, contentBuilderKey.value, [])
    })

</script>

<style lang="scss" scoped>

</style>
